import axios from 'axios';
import useSWRMutation from 'swr/mutation';
import { parseYapilyError } from '../../../../utils/parse-yapily-error';

type ReAuthLinkArgs = {
  companyId: string;
  institutionId: string;
  accountId: string;
  userName: string;
  psuId?: string;
};

/**
 * Hook to trigger re-authorization for an expired open banking connection
 * Uses Yapily's reAuthoriseAccount endpoint
 */
export const useReAuthLink = () => {
  return useSWRMutation<{ link: string }, Error, string, ReAuthLinkArgs>(
    '/api/yapily/re-auth-link',
    async (url, { arg }) => {
      const params = new URLSearchParams(Object.entries(arg).filter(([, v]) => v !== undefined) as [string, string][]);

      try {
        const response = await axios.get(`${url}?${params.toString()}`);
        return response.data;
      } catch (error) {
        const errorMessage = parseYapilyError(error);
        throw errorMessage ? new Error(errorMessage) : error;
      }
    },
  );
};
